import { ChangeDetectionStrategy, Component, ViewEncapsulation } from '@angular/core';

import { isActiveMobileInterface } from '@app/modules/core/mappers/mobile-interface.mapper';
import { endCallWebView } from '@app/modules/core/util/redirect-login';
import { ButtonIconSize } from '@design-system/components/molecules/button-icon/entities/button-icon.types';
import { Icon } from '@design-system/components/atoms/icon/entities/icon.types';

@Component({
  selector: 'app-maintenance-page',
  templateUrl: './maintenance-page.container.html',
  styleUrls: ['./maintenance-page.container.sass'],
  encapsulation: ViewEncapsulation.ShadowDom,
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class MaintenancePageComponent {

  public readonly IMAGE: string = 'something-went-wrong.png';
  public readonly IMAGES_BASE_PATH: string = 'web/travel/maintenance-page';

  public loaderByClose = false;

  public readonly buttonIconSize = ButtonIconSize.LG;
  public readonly iconChevronRight = Icon.ChevronLeft;

  constructor() { }

  get isMobileDevice(): boolean {
    return isActiveMobileInterface();
  }

  public goBack(): void {
    this.loaderByClose = true;
    endCallWebView();
  }

}
